import React from 'react';
import LoadingAsyncTask from 'components/loading/async-task';

export default function AsyncUploadAppStatus({ app, onCompleted }) {
  return (
    <LoadingAsyncTask
      record={app}
      onCompleted={onCompleted}
      endpoint="apps"
      tasks={[{ type: 'upload_theme', label: 'Uploading theme' }]}
    />
  );
}
